<template>
  <aside 
    class="w-64 bg-white dark:bg-gray-800 text-[#035a76] dark:text-gray-200 shadow-lg flex-shrink-0 fixed h-full z-10 transition-all duration-300"
    :class="{'ml-0': isOpen, '-ml-64': !isOpen}"
  >
    <div class="p-6 flex items-center space-x-2 border-b border-gray-200 dark:border-gray-700">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
      <span class="text-2xl font-bold">Communication</span>
    </div>
<nav class="mt-6 overflow-y-auto h-[calc(100%-80px)] scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 dark:scrollbar-thumb-gray-600 dark:scrollbar-track-gray-800">
        <ul class="space-y-1 px-2 pb-6">
        <!-- Dashboard -->
        <!-- <li>
          <RouterLink 
            to="/academics-dashboard" 
            class="flex items-center px-6 py-3 text- hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Dashboard
          </RouterLink>
        </li> -->
         <!-- Dashboard -->
        <li>
          <RouterLink 
            to="/com-dashboard" 
            class="flex items-center px-6 py-3 text- hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Dashboard
          </RouterLink>
        </li>
        <li>
          <RouterLink 
            to="/com-users" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20h6m-3-4a4 4 0 100-8 4 4 0 000 8zm-6-4a6 6 0 0112 0v5H3v-5z" />
            </svg>
            Users
          </RouterLink>
        </li>
     
             <li>
          <RouterLink 
            to="/staff-pictures" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
            </svg>
            Pictures
          </RouterLink>
        </li>
      <li>
          <RouterLink 
to="/com/onboarding"
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
            </svg>
            Onboarding Form
          </RouterLink>
        </li>
          <li>
          <RouterLink 
            to="/com-personal-info" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
        d="M5.121 17.804A9 9 0 1118.88 17.804M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
</svg>
          Information
          </RouterLink>
        </li>


        <!-- Manpower -->
        <!-- <li>
          <RouterLink 
            to="/calendar" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20h6m-3-4a4 4 0 100-8 4 4 0 000 8zm6-4a6 6 0 00-12 0v5h12v-5z" />
            </svg>
            <i class="fa-solid fa-calendar mr-3"></i>
Calendar
          </RouterLink>
        </li> -->
              <!-- <li>
  <button
    @click="toggleMasterData"
    class="flex items-center justify-between w-full px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
  >
    <div class="flex items-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M4 6h16M4 12h16M4 18h16" />
      </svg>
      Master Data
    </div>

    <svg
      :class="{ 'rotate-180': showMasterData }"
      class="h-4 w-4 transition-transform duration-200"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <ul v-show="showMasterData" class="bg-gray-100 dark:bg-gray-800">

    <li>
      <RouterLink to="/terms"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
Terms
      </RouterLink>
    </li>

    <li>
      <RouterLink to="/academic-years"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        Academic Years
      </RouterLink>
    </li>

    <li>
      <RouterLink to="/holiday-types"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
HolidayType
      </RouterLink>
    </li>

    <li>
      <RouterLink to="/sections"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        Sections
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/classes"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        Classes
      </RouterLink>
    </li>
        <li>
      <RouterLink to="/subjects"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        Subjects
      </RouterLink>
    </li>
  </ul>
</li> -->
      </ul>
    </nav>
  </aside>
</template>

<script setup>
import { ref } from 'vue';
defineProps({
  isOpen: {
    type: Boolean,
    required: true
  }
});
const showMasterData = ref(false)

const toggleMasterData = () => {
  showMasterData.value = !showMasterData.value
}
</script>

<style scoped>
.router-link-active {
  background-color: #74bd54;
  color: white !important;
  font-weight: 600;
}
</style>